/**
 * Client HTTP de l'API WordPress (https://ambpicot.pro/api) : connexion, proxy Airtable, commerciaux, devises, fichiers.
 *
 * Le pare-feu d'o2switch (Tiger Protect) répond à certains POST, selon l'adresse IP du visiteur, par un « challenge » :
 * une redirection 307 vers la même adresse, avec un cookie (o2s-chl). La même requête, renvoyée avec ce cookie, passe.
 * L'API n'est pas sur le même domaine que l'application : sans cookies, le navigateur bloque cette redirection (elle n'a
 * pas d'en-tête CORS) et ne garde pas le cookie. La requête échoue alors à chaque fois (« Network Error »).
 *
 * Ce client fait donc trois choses :
 * - withCredentials : le navigateur garde le cookie du challenge et le renvoie. L'authentification reste le session_id.
 * - { replayable: true } : après un échec réseau, la requête est renvoyée une seule fois. Le premier envoi a posé le
 *   cookie, le second passe. À réserver aux requêtes sans risque de doublon (connexion, lecture, modification,
 *   suppression) : un échec réseau ne dit pas si le serveur a traité la requête.
 * - Les autres POST (création, envoi de fichier) ne sont jamais renvoyés : un « ping » sans effet, lui rejouable, passe
 *   le challenge juste avant.
 */
import axios from "axios";

export const API_URL = (process.env.VUE_APP_API_URL || "https://ambpicot.pro/api").replace(/\/+$/, "");

const api = axios.create({ baseURL: API_URL, withCredentials: true });

api.interceptors.request.use((config) => {
	if (config.method !== "post" || config.replayable) {
		return config;
	}
	// L'échec du ping est ignoré : la requête elle-même dira l'erreur s'il y en a une.
	const proceed = () => config;
	return api.post("/ping/", null, { replayable: true }).then(proceed, proceed);
});

api.interceptors.response.use(undefined, (error) => {
	const config = error.config;
	// Une réponse du serveur, même en erreur, n'est pas un challenge : seul l'échec réseau est rejoué, une seule fois.
	if (error.response || !config || !config.replayable || config.replayed) {
		return Promise.reject(error);
	}
	config.replayed = true;
	return api.request(config);
});

export default api;
